import { render, staticRenderFns } from "./RemindTool.vue?vue&type=template&id=065636ed"
import script from "./RemindTool.vue?vue&type=script&lang=js"
export * from "./RemindTool.vue?vue&type=script&lang=js"
import style0 from "./RemindTool.vue?vue&type=style&index=0&id=065636ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports